import React from "react";
import EditorialCard from "../components/EditorialCard";
import personalData from "../config/personalData";

export default function Works() {
  const { works, theme } = personalData;

  return (
    <main className="mx-auto max-w-5xl px-6 pb-24 pt-10 md:pt-14">
      <section className="max-w-3xl">
        <h1
          className="motion-fade-up font-bodoni text-5xl leading-none md:text-6xl"
          style={{ color: theme.colors.accent }}
        >
          {works.title}
        </h1>
        <p
          className="motion-fade-up motion-delay-1 mt-5 text-lg leading-8"
          style={{ color: theme.colors.muted }}
        >
          {works.description}
        </p>
      </section>

      <section className="mx-auto mt-12 grid max-w-5xl grid-cols-1 justify-items-center gap-10 sm:grid-cols-2 lg:grid-cols-3">
        {works.items.map((work, index) => (
          <EditorialCard
            key={work.id}
            image={work.imgURL}
            imageAlt={work.alt}
            title={work.title}
            description={work.desc}
            href={work.url}
            linkLabel={work.linkLabel || "view project"}
            meta={work.details?.timeline}
            tags={work.subtitles}
            minimal={work.minimal}
            index={index + 2}
            textAnimationDelay="0.36s"
            imageAnimationDelay="0.6s"
          />
        ))}
      </section>
    </main>
  );
}
